export default "__VITE_ASSET__Dz2k$_PP__"